import {
  BrowserClient,
  Dedupe,
  defaultStackParser,
  HttpContext,
  Integrations,
  LinkedErrors,
  makeFetchTransport,
} from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import { config } from './config';

let SentryClient: BrowserClient;

export const initializeSentry = () => {
  const isSentryEnabled = config.features.sentry.enabled && !IS_DEVELOPMENT;

  if (isSentryEnabled) {
    SentryClient = new BrowserClient({
      dsn: SENTRY_CONTAINER,
      integrations: [
        new Integrations.InboundFilters(),
        new Integrations.FunctionToString(),
        new LinkedErrors(),
        new Dedupe(),
        new HttpContext(),
        new BrowserTracing(),
      ],
      transport: makeFetchTransport,
      stackParser: defaultStackParser,
      environment: config.isProduction ? 'production' : 'staging',
      release: RELEASE_ID,
      tracesSampleRate: 0,
      sampleRate: 1,
      attachStacktrace: true,
    });
    window.addEventListener('error', event => {
      if (event.error.stack.includes('ay-checkout')) {
        console.log('Window error reported');
        SentryClient.captureException(event);
      }
    });
  }
};

export const reportErrorToSentry = (error: any) => {
  if (SentryClient) {
    console.log('Sentry captured error with handler', error);
    SentryClient.captureException(error);
  }
};
